"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMultiSelectOptionToString = void 0;
var _i18n = require("../../../i18n/i18n");
var _utils = require("../utils");
const useMultiSelectOptionToString = (optionToString, inputValue) => {
  const {
    i18n
  } = (0, _i18n.useI18n)();
  return option => {
    if (option === null) {
      // This is a downshift-ism that we'll hide from our consumers.
      // This doesn't really apply in the multiselect case but this null comes from
      // downshift sharing the same handler for the multiselect and select. The select
      // CAN have a null selection.

      return "";
    } else if ((0, _utils.isCreatableMarkerOption)(option)) {
      return i18n._( /*i18n*/{
        comment: "When selected, this component will create a new option with the label 'inputValue' and add it to the list of options",
        id: `Add "{inputValue}"`,
        values: {
          inputValue
        }
      });
    } else if ((0, _utils.isSelectAllMarkerOption)(option)) {
      return i18n._( /*i18n*/{
        comment: "This selects all of the available options in the multi-select",
        id: `Select All`
      });
    } else {
      return optionToString(option);
    }
  };
};
exports.useMultiSelectOptionToString = useMultiSelectOptionToString;
//# sourceMappingURL=useOptionToString.js.map